import * as React from 'react';

import * as _ from 'lodash';
import * as Bluebird from 'bluebird';
import { v4 as UUID } from 'uuid';

import { makeStyles } from '@material-ui/core/styles';

import { Switch, Route, useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    Typography,
    AppBar, Tabs, Tab, Toolbar,
    Button, IconButton, Switch as SwitchComp,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider,
    Dialog, DialogTitle, DialogContent, DialogActions,
    FormControlLabel
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';

import { useSnackbar } from 'notistack';

import { LouverSelector, LouverSelectorProps } from '../louverSelector';
import { LayoutEntity, LayoutEntityProps } from '../layoutEntity';
import { LayoutGrid, LayoutGridProps } from '../layoutGrid';

import {
    useGrdSupplyGrilles,
    useEntityXM,
    useGridXM,
    useDiagnosticXM
} from '../xm';

const styles = makeStyles((theme) => ({
    root: {
        // background: '#c6cacf'
    },
    grow: {
        flexGrow: 1
    },
    sizesToolbar: {
        alignItems: 'flex-start'
    },
    sizesToolbarHeader: {
        flexGrow: 1
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    paperContainer: {
        padding: theme.spacing(1)
    },
    entityContainer: {
        padding: theme.spacing(1),
        background: '#F2F3F4'
    },
    textarea: {
        // resize: 'vertical',
        fontSize: 8,
        overflow: 'auto',
        maxWidth: '100%',
        maxHeight: 400
        // whiteSpace: 'nowrap'
    },
    test: {
        padding: theme.spacing(2)
    }
}));

export function Grd() {
    const classes = styles();

    const [ debugging, setDebugging ] = React.useState<boolean>(true);
    const [ macro, setMacro ] = React.useState<string>(`{Eval|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|DamperType|NULL}' = 'RadialShutter') and !({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= true|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|DamperType|NULL}' = 'RadialShutter') and ({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= {Calc|6 <= {Calc|{QV|Neck1_Enum|-1} < {QV|Neck2_Enum|-1} ? {QV|Neck1_Enum|-1} : {QV|Neck2_Enum|-1}} ? true:false}|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|DamperType|NULL}' = 'Butterfly') and !({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= true|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|DamperType|NULL}' = 'Butterfly') and ({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= {Calc|6 <= {Calc|{QV|Neck1_Enum|-1} < {QV|Neck2_Enum|-1} ? {QV|Neck1_Enum|-1} : {QV|Neck2_Enum|-1}} ? true:false}|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|GridType|NULL}' in 'Round' and !'{QV|DamperType|NULL}' in 'Butterfly,RadialShutter') and !({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= true|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|GridType|NULL}' in 'Round' and !'{QV|DamperType|NULL}' in 'Butterfly,RadialShutter') and ({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= {Calc|6 <= {Calc|{QV|Neck1_Enum|-1} < {QV|Neck2_Enum|-1} ? {QV|Neck1_Enum|-1} : {QV|Neck2_Enum|-1}} ? true:false}|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|GridType|NULL}' in 'Rectangular,None' and !'{QV|DamperType|NULL}' in 'Butterfly,RadialShutter') and !({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= true|('{QV|TransitionType|NULL}' in 'RoundDeep') and ('{QV|GridType|NULL}' in 'Rectangular,None' and !'{QV|DamperType|NULL}' in 'Butterfly,RadialShutter') and ({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= {Calc|6 <= {Calc|{QV|Neck1_Enum|-1} < {QV|Neck2_Enum|-1} ? {QV|Neck1_Enum|-1} : {QV|Neck2_Enum|-1}} ? true:false}|('{QV|TransitionType|NULL}' in 'Round') and ('{QV|GridType|NULL}' in 'Round') and !({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= true|('{QV|TransitionType|NULL}' in 'Round') and ('{QV|GridType|NULL}' in 'Round') and ({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= {Calc|6 <= {Calc|{QV|Neck1_Enum|-1} < {QV|Neck2_Enum|-1} ? {QV|Neck1_Enum|-1} : {QV|Neck2_Enum|-1}} ? true:false}|('{QV|TransitionType|NULL}' in 'Round') and ('{QV|GridType|NULL}' in 'Rectangular,None') and !({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= true|('{QV|TransitionType|NULL}' in 'Round') and ('{QV|GridType|NULL}' in 'Rectangular,None') and ({QV|Neck1_Enum|-1} != -1 and {QV|Neck2_Enum|-1} != -1) ?= {Calc|6 <= {Calc|{QV|Neck1_Enum|-1} < {QV|Neck2_Enum|-1} ? {QV|Neck1_Enum|-1} : {QV|Neck2_Enum|-1}} ? true:false}|('{QV|TransitionType|NULL}' = 'None') ?= false|true}`);

    const {
        addSize,
        sizingEntity, updateSizingEntity,
        sizingGrid, updateSize, refreshSizingGrid,
        testMacro
    } = useGrdWorkflow('SupplyGrilles', 'Caps', 'Tab.SizesQuantities');

    const onSpamTest = () => {
        updateSizingEntity({
            'BorderType': 'T_BarLay_In'
        });
        updateSizingEntity({
            'FinishColor': 'SatinSilver'
        });
        updateSizingEntity({
            'TransitionType': 'Round'
        });
        updateSizingEntity({
            'PlasterFrame': 'SurfaceMounted'
        });
    }

    const onRefresh = () => {
        refreshSizingGrid();
    }

    const onTestMacro = () => {
        testMacro(macro);
    }

    return (
        <React.Fragment>
            <Grid container xs={12} spacing={1} alignItems="flex-start">
                <Grid item xs={12}>
                    <FormControlLabel label="Enable Debugging" control={<SwitchComp checked={debugging} onChange={() => setDebugging(!debugging)} />} />
                    <Button onClick={onSpamTest}>Spam Test</Button>
                    <Button onClick={onRefresh}>Refresh</Button>
                    <Button onClick={onTestMacro}>Test Macro</Button>
                </Grid>

                <Grid item xs={12}>
                    <TextField fullWidth label="Macro" value={macro} onChange={(e) => setMacro(e.target.value)} />
                </Grid>

                <Grid item xs={12}>
                    <Paper variant="outlined">
                        <AppBar position="static">
                            <Toolbar variant="dense">
                                <Typography variant="h6">GRD Sizing</Typography>
                                <div className={classes.grow}></div>
                                <IconButton edge="start" color="inherit">
                                    <Icons.Add onClick={addSize} />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <div className={classes.test}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {sizingEntity ? <LayoutEntity debugging={debugging} entity={sizingEntity} onChange={e => updateSizingEntity(e.state)} /> : <em>Loading sizing entity...</em>}
                                </Grid>

                                <Grid item xs={12}>
                                    {sizingGrid ? <LayoutGrid debugging={debugging} grid={sizingGrid} onChange={e => updateSize(e)} /> : <em>Loading sizing sizes grid...</em>}
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

const useGrdWorkflow = (productType: string, application: string, tab: string) => {
    const [ grdSizingContext, addSupplyGrilleSize ] = useGrdSupplyGrilles(productType, application);

    const [ sizingEntity, updateSizingEntityBase, refreshSizingEntity ] = useEntityXM(grdSizingContext.entityKey, grdSizingContext.layouts[tab]?.layout);
    const [ sizingGrid, refreshSizingGrid ] = useGridXM(grdSizingContext.entityKey, grdSizingContext.layouts[tab]?.grid);

    const [ test, resolveMacro ] = useDiagnosticXM();

    const updateSizingEntity = async (updates: Record<string, string>) => {
        updateSizingEntityBase && await updateSizingEntityBase(updates);
        refreshSizingGrid && await refreshSizingGrid();
    }

    const updateSize = async (payload: { id: string, state: Record<string, string> }) => {
        const updatePayload: Record<string, string> = {};
        for (let key in payload.state)
            updatePayload[`${payload.id}.${key}`] = payload.state[key];

        updateSizingEntityBase && await updateSizingEntityBase(updatePayload);
        refreshSizingGrid && await refreshSizingGrid();
    }

    const addSize = async () => {
        await addSupplyGrilleSize();
        await refreshSizingGrid();
    }

    const testMacro = async (macro: string) => {
        const results = await resolveMacro(grdSizingContext.entityKey, macro, context.sizingGrid?.rows[0].entityId)
        console.log('RESOLVED MACRO', results);
    }

    const context = {
        addSize,
        sizingEntity, updateSizingEntity, refreshSizingEntity,
        sizingGrid, refreshSizingGrid,
        updateSize,
        testMacro
    }

    return context;
}